import React from "react";
import StaticContentPage from "./StaticContentPage";
import { aboutUsText } from "../data/staticPagesContent";

const AboutUs = () => {
  return (
    <StaticContentPage
      title="About Us"
      seoTitle="About Us | Eveness AI Fashion Platform"
      seoDescription="Learn about Eveness, an AI-powered fashion platform helping shoppers discover products, styling ideas, and personalized outfit guidance."
      canonicalPath="/about-us"
    >
      {aboutUsText}
    </StaticContentPage>
  );
};

export default AboutUs;